import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IAlternatingItems {
	/**
	 * Image should be 523px X 392px
	 */
	image?: IImage;
	/**
	 * Item title
	 */
	heading?: string;
	/**
	 * Item content
	 * @control richtext
	 */
	content?: string;
	/**
	 * Button link
	 */
	link?: ILink;
}

export interface IAlternatingTextAndImageProps extends IBaseElementProps {
	contentRows?: IAlternatingItems[];
}

/**
 * Alternating Text And Image
 * @icon id
 * @block
 */

const AlternatingTextAndImage: React.FC<IAlternatingTextAndImageProps> = ({
	contentRows = [],
	className,
	classNames = [],
}) => (
	<div className={className || cn('alternating-content', ...classNames)}>
		{contentRows.length > 0 &&
			contentRows.map(({ image, heading, content, link }, i) => (
				<div
					className={cn(
						'alternating-content-container row mx-0 mx-md-auto px-3 justify-content-center',
						i % 2 !== 0
							? 'flex-row-reverse justify-content-lg-between'
							: 'justify-content-lg-start',
					)}
				>
					<div className="alternating-content-container__image-wrapper">
						<Image {...image} />
					</div>
					<div className="alternating-content-container__content-wrapper col-12 col-md">
						{heading && <h3 className="heading">{heading}</h3>}
						{content && (
							<div
								className="content"
								dangerouslySetInnerHTML={{
									__html: content,
								}}
							/>
						)}
						{link && link.href && <Button {...link} size="sm" />}
					</div>
				</div>
			))}
	</div>
);

export default AlternatingTextAndImage;
